import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { ProfileAuthGuard } from './';

@Injectable({
    providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
    constructor(private _profileService: ProfileAuthGuard) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const modifiedReq = req.clone({
            setHeaders: {
                'pmis-profile-id': this._profileService.profileId,
            },
        });
        return next.handle(modifiedReq);
    }
}
